export default "__VITE_ASSET__C8YaoH6M__"